export * from './borderer-editable-text-strategy.component';
